import { render, staticRenderFns } from "./StockResearch.vue?vue&type=template&id=cd0c6c24&"
import script from "./StockResearch.vue?vue&type=script&lang=js&"
export * from "./StockResearch.vue?vue&type=script&lang=js&"
import style0 from "./StockResearch.vue?vue&type=style&index=0&id=cd0c6c24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports